// Constants used to identify elements and toggle scroll animation states
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

/**
 * Intersection Observer callback to handle visibility changes
 * Adds or removes offscreen classes and sets animation order if cascading is enabled
 */
function onIntersection(entries, observer) {
    entries.forEach((entry, index) => {

        const el = entry.target;

        if (entry.isIntersecting) {
            // Element just came into view

            if (el.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
                el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);

                // Optional cascading effect via custom property
                if (el.hasAttribute('data-cascade')) {
                    el.style.setProperty('--animation-order', index);
                }
            }

            // Unobserve once animation is triggered (one-time effect)
            observer.unobserve(el);

        } else {
            // Element left the viewport before animating
            // Re-apply the offscreen class to allow it to trigger again (optional depending on use-case)
            el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
            el.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
        }

    });
}

/**
 * Initialise scroll-trigger animations within a given root element
 * @param {HTMLElement|Document} rootEl - The container to search within
 */
export function initialiseScrollAnimationTrigger(rootEl = document) {
    const animationTriggerElements = Array.from(
        rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
    );

    if (animationTriggerElements.length === 0) return;

    const observer = new IntersectionObserver(onIntersection, {
        // Start animation slightly before full visibility
        rootMargin: '0px 0px -50px 0px',
    });

    // Observe each element for scroll-in animation triggering
    animationTriggerElements.forEach((element) => {
        observer.observe(element);
    });
}